import React from 'react';
import {Box, Typography} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CloseIcon from '@mui/icons-material/Close';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ICONES = {check: CheckIcon, warning: WarningAmberIcon, close: CloseIcon, hourglass: HourglassEmptyIcon, error: ErrorOutlineIcon};

/**
 * Bandeau verdict d'un scénario (GUIDE_UI : pastille 52 px, titre, sous-ligne, action à droite). Le contenu vient de
 * `verdictSimulation` (atelierRules). AJOUT À VALIDER : le VerdictBanner existant (interventions/v2) est lié aux champs
 * d'une intervention (passage, opérateur, typologie) ; on reprend ses tokens, pas son contenu.
 */
function VerdictSimulation({verdict, sousLigne, details = [], actions}) {
    if (!verdict) return null;
    const Icone = ICONES[verdict.icon] ?? CheckIcon;
    return (
        <Box data-testid="verdict" data-etat={verdict.etat} sx={{
            background: verdict.gradient, border: `1px solid ${verdict.border}`, borderRadius: '16px',
            p: 2, display: 'flex', alignItems: 'center', gap: 2, flex: 'none',
        }}>
            <Box sx={{width: 52, height: 52, borderRadius: '50%', bgcolor: verdict.dot, color: '#fff', flex: 'none',
                display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(16,46,105,.12)'}}>
                <Icone sx={{fontSize: 30}}/>
            </Box>
            <Box sx={{flex: '1 1 auto', minWidth: 0}}>
                <Typography component="h2" sx={{fontSize: 22, fontWeight: 800, lineHeight: 1.2, color: verdict.titleColor}}>{verdict.texte}</Typography>
                {verdict.erreur && <Typography sx={{fontWeight: 600, color: '#B22222'}}>{verdict.erreur}</Typography>}
                {verdict.signal && <Typography sx={{fontWeight: 600, color: '#5A6470'}}>Campagne : {verdict.signal}</Typography>}
                {sousLigne && <Typography sx={{fontWeight: 600, color: '#5A6470'}}>{sousLigne}</Typography>}
                {details.map((d) => <Typography key={d} data-testid="non-affectees" sx={{fontSize: 13, fontWeight: 600, color: '#B22222'}}>{d}</Typography>)}
            </Box>
            {actions && <Box sx={{flex: 'none', display: 'flex', alignItems: 'center', gap: 1}}>{actions}</Box>}
        </Box>
    );
}

export default VerdictSimulation;
